import { KibsiClient } from './base';
const SERVICE = 'realtime-data';
export class RealtimeDataKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, SERVICE);
    }
    createSubscription(subscription, requestConfig) {
        return this.post(`subscriptions`, subscription, requestConfig);
    }
    endpoint(requestConfig) {
        return this.get(`/ws/endpoint`, requestConfig);
    }
    deploymentSnapshot(deploymentId, itemType, requestConfig) {
        return this.get(`deployments/${deploymentId}/snapshot`, {
            ...requestConfig,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            params: {
                ...requestConfig?.params,
                itemType,
            },
        });
    }
}
//# sourceMappingURL=realtime-data.js.map